export const odluka_DPO= {
    templateId: 90.5,
    category: 9,
    templateTitle: 'Odluka o imenovanju službenika za zaštitu osobnih podataka - DPO',
    templateDescription: `Imenovanje službenika za zaštitu osobnih podataka obveza je voditelja ili izvršitelja obrade u određenim slučajevima koje propisuje Uredba.`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
    <p>Voditelj obrade i izvršitelj obrade dužni su imenovati službenika za zaštitu podataka (DPO) u sljedećim slučajevima:</p>
    <li> obradu provodi tijelo javne vlasti ili javno tijelo, osim za sudove koji djeluju u okviru svoje sudske nadležnosti,</li>
    <li> osnovne djelatnosti voditelja obrade ili izvršitelja obrade sastoje se od postupaka obrade koji zbog svoje prirode, opsega i/ili svrha iziskuju redovito i sustavno praćenje ispitanika u velikoj mjeri, ili osnovne djelatnosti voditelja obrade ili izvršitelja obrade sastoje se od opsežne obrade posebnih kategorija podataka u skladu s odredbama Opće uredbe o zaštiti podataka i osobnih podataka u vezi s kaznenim osudama i kažnjivim djelima u skladu s odredbama Opće uredbe o zaštiti podataka.</li>
    <br>
    <p>Službenik za zaštitu podataka imenuje se na temelju stručnih kvalifikacija, a osobito stručnog znanja o pravu i praksama u području zaštite podataka te sposobnosti izvršavanja obveza koje propisuje Opća Uredba o zaštiti podataka.</p>
    <p>Službenik za zaštitu podataka može biti radnik voditelja obrade ili izvršitelja obrade ili obavljati zadaće na temelju ugovora o djelu. </p>
    <p>Grupa poduzetnika može imenovati jednog službenika za zaštitu podataka pod uvjetom da je službenik za zaštitu podataka lako dostupan iz svakog poslovnog nastana.</p>
    <p>Voditelj obrade ili izvršitelj obrade objavljuje kontaktne podatke službenika za zaštitu podataka.</p>
    <p>Kod objave kontaktnih podataka službenika za zaštitu podataka preporuka je izbjegavati navođenje osobnih podataka službenika: ime i prezime, osobni telefon, osobni e-pretinac ili druge osobne podatke, nego navesti samo: adresa i mjesto rada službenika za zaštitu osobnih podataka, te službeni telefon i službeni e-pretinac ako postoje.</p>
    <p>Osim toga, voditelj ili izvršitelj obrade kontakt podatke službenika za zaštitu osobnih podataka je dužan priopćiti nadzornom tijelu.</p>
    <p>U tom smislu, nadzornom tijelu može dostaviti Odluku o imenovanju u izvorniku, potpisanu od odgovorne osobe i potvrđenu pečatom voditelja, ako su u Odluci navedeni svi obvezni podaci o imenovanju službenika za zaštitu osobnih podatka radi uvrštenja u registar službenika za zaštitu osobnih podataka.</p>

    <p>Radi jednostavnijeg izvještavanja Nadzornog tijela (AZOP) o imenovanju službenika za zaštitu osobnih podataka AZOP je sačinio sljedeći <a target="_blank" href="https://azop.hr/imenovanje-sluzbenika-za-zastitu-podataka-2/">Obrazac</a>.</p>
    <p>Važno je naglasiti da službenik za zaštitu osobnih podataka ima i pečat te se istim ovjerava, kako navedeni obrazac, tako i eventualna Odluka o imenovanju službenika za zaštitu podataka koja se umjesto obrasca može dostaviti u AZOP. </p>


    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>UREDBA (EU) 2016/679 EUROPSKOG PARLAMENTA I VIJEĆA od 27. travnja 2016. o zaštiti pojedinaca u vezi s obradom osobnih podataka i o slobodnom kretanju takvih podataka te o stavljanju izvan snage Direktive 95/46/EZ (Opća uredba o zaštiti podataka).</p>
  `,
    sides: [
        {
            prefix: 'Zakona o provedbu Opće Uredbe o zaštiti podataka,',
            signature: 'Za Voditelja obrade:',
            inputs: [{
                type: "input",
                required: true,
                placeholder: "Poslovni subjekt",
              },
              {
                type: "input",
                required: true,
                placeholder: "Ulica i kućni broj",
              },
              {
                type: "input",
                required: true,
                placeholder: "Mjesto",
              },
              {
                type: "input",
                required: true,
                placeholder: "OIB",
              },
              {
                type: "input",
                placeholder: "Zastupa",
                inSignature: true,
              },
              {
                type: "input",
                placeholder: "Funkcija",
                inSignature: true,
              }],
            suffix: ' (u daljnjem tekstu: Voditelj obrade),',
        }
    ],

    headline: '​donosi sljedeću',
    title: 'ODLUKU O IMENOVANJU SLUŽBENIKA ZA ZAŠTITU OSOBNIH PODATAKA',
    noArticleNumbers: true,

    articles: [
        
        {
            title: '',
            mandatory: true,
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: false,
                    content: 'Kod Voditelja obrade se obavlja obrada sljedećih kategorija osobnih podataka: ',
                },
                {
                    type: 'text',
                    required: true,
                    mandatory: true,
                    editable: true,
                    content: '',
                    value: '',
                },
            ],
            value: '',
        },   
        {
            title: "",
            mandatory: true,
            statements: [
              {
                type: "input",
                mandatory: true,
                parts: [
                    { type: 'input', value: '', required: true, placeholder: "Ime i prezime" },
                      { type: "text", content: "," },
                      { type: 'text', content: 'iz',},
                      { type: 'input', value: '', required: true, placeholder: "Mjesto"   },
                      { type: 'text', content: ',' },
                      { type: 'input', value: '', required: true, placeholder: "Ulica i kućni broj" },
                      { type: "text", content: "," },
                      { type: 'text', content: 'OIB:' },
                      { type: "input",  required: true,},
                      { type: "text", content: "," },
                      { type: "input",  required: true, placeholder: "broj službenog telefona"},
                    { type: "text", content: "," },
                    { type: "input",  required: true, placeholder: "službena e-mail adresa"},
                    { type: "text", content: "," },
                    { type: "text", content: "imenuje se službenikom za zaštitu osobnih podataka." },
                ],
              }
            ]
          },
          {
            title: '',
            mandatory: true,
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: false,
                    content: 'Dužnosti službenika za zaštitu osobnih podataka su sljedeće:\r\n',
                },
                {
                    type: 'text',
                    mandatory: true,
                    editable: true,
                    content: '-informiranje i savjetovanje voditelja obrade ili izvršitelja obrade te zaposlenika koji obavljaju obradu o njihovim obvezama iz Opće Uredbe o zaštiti podataka (u daljnjem tekstu: Uredba) te drugim odredbama Europske Unije ili države članice o zaštiti podataka,\r\n- praćenje poštovanja Uredbe te drugih odredaba Europske Unije ili države članice o zaštiti podataka i politika Voditelja obrade ili izvršitelja obrade u odnosu na zaštitu osobnih podataka, uključujući raspodjelu odgovornosti, podizanje svijesti i osposobljavanje osoblja koje sudjeluje u postupcima obrade te povezane revizije, \r\n- pružanje savjeta, kada je to zatraženo, u pogledu procjene učinka na zaštitu podataka i praćenje njezina izvršavanja s obvezama koje se odnose na procjenu učinka na zaštitu podataka, \r\n- suradnja s nadzornim tijelom, \r\n- djelovanje kao kontaktna točka za nadzorno tijelo o pitanjima u pogledu obrade, što uključuje i prethodno savjetovanje s nadzornim tijelom te savjetovanje, prema potrebi, o svim drugim pitanjima, \r\n- voditi računa o riziku povezanom s postupcima obrade i uzima u obzir prirodu, opseg, kontekst i svrhe obrade, \r\n- čuvati povjerljivost svih informacija i podataka koje sazna u obavljanju svojih dužnosti.',
                    help: "Ovdje navedene dužnosti su propisane Uredbom, stoga u slučaju eventualnih izmjena provjerite odredbe Uredbe.",
                    value: '',
                }],
        },
        {
            title: '',
            mandatory: true,
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: true,
                    content: 'Poslodavac osigurava da službenik za zaštitu podataka ne prima nikakve upute u pogledu izvršenja svojih obveza.\r\nPoslodavac ne smije službenika za zaštitu osobnih podataka razriješiti dužnosti ili kazniti zbog izvršavanja njegovih zadaća.  \r\nSlužbenik za zaštitu podataka izravno odgovara najvišoj rukovodećoj razini Voditelja obrade.  \r\nSlužbenik za zaštitu podataka može ispunjavati i druge zadaće i dužnosti.  \r\nVoditelj obrade osigurava da takve zadaće i dužnosti ne dovedu do sukoba interesa.',
                    value: '',
                }],
        },
        {
            title: '',
            mandatory: true,
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: true,
                    content: 'Poslodavac će na prikladnom mjestu objaviti sljedeće kontakt podatke službenika za zaštitu osobnih podataka adresa i mjesto rada službenika za zaštitu osobnih podataka te službeni telefon i službenu e-mail adresu. \r\nOsim toga, o imenovanju će biti obaviješten i Nadzorno tijelo (AZOP) dokumentom koji će imati ovjeru i potpis službenika za zaštitu osobnih podataka.',
                    value: '',
                }],
        },  
          {
            title: "",
            mandatory: true,
            statements: [
              {
                type: "input",
                mandatory: true,
                parts: [
                    { type: "text", content: "Ova Odluka se primjenjuje od dana" }, 
                    { type: "input", value: "", required: true },
                    { type: "text", content: "godine, sve do opoziva."}, 
                ],
              }
            ]
          },
        {
            mandatory: true,
            static: true,
            type: 2, // date and place
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    parts: [
                        {
                            type: 'text',
                            content: 'U'
                        },
                        {
                            type: 'input',
                            value: '',
                            placeholder: "Upišite mjesto.",
                            required: true
                        },
                        {
                            type: 'text',
                            content: ', dana'
                        },
                        {
                            type: 'date',
                            value: new Date(),
                            required: true
                        },
                        {
                            type: 'text',
                            content: 'godine.',
                        }
                    ]
                },
            ]
        },
        {
            mandatory: true,
            static: true,
            type: 3,  // signatures
            statements: [],
        },
        {
            static: true,
            mandatory: false,
            type: 4, 
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: true,
                    content: 'Dostaviti:\r\n1) Službeniku za zaštitu osobnih podataka\r\n2) Agencija za zaštitu osobnih podataka \r\n3) Arhiva',
                    help: 'Po želji, slobodno dopišite kome želite dostaviti odluku odnosno izmijenite/obrišite predložene unose.'
                }
            ]
        },
    ],
};





// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/90.5_odluka_DPO.ts